import { render } from "./SalesforceMonitoringDashboard.vue?vue&type=template&id=0abc6558&scoped=true"
import script from "./SalesforceMonitoringDashboard.vue?vue&type=script&lang=js"
export * from "./SalesforceMonitoringDashboard.vue?vue&type=script&lang=js"

import "./SalesforceMonitoringDashboard.vue?vue&type=style&index=0&id=0abc6558&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abc6558"]])

export default __exports__